import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Button } from '@material-ui/core';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    padding: 0,
    width: '100%',
    color: palette.colorBtnTxt,
    background: palette.colorBtn,
    marginBottom: '10px',
    minHeight: 50,
    font: '17px SofiaPro-SemiBold',
    boxShadow: `0 0px 5px 0 ${palette.colorBtnTxt}, 0 0px 0px 0 #f4bdbe`,
    border: `2px solid ${palette.colorBtnTxt}`,
    letterSpacing: '0.3px',
  },
}));

const OutlineButton = ({
  children, onClick, disabled, type, style,
}) => {
  const classes = useStyles();

  return (
    <Button style={style} type={type} disabled={disabled} className={classes.root} onClick={onClick}>
      { children }
    </Button>
  );
};

OutlineButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: '',
  style: {},
};

OutlineButton.propTypes = {
  style: PropTypes.object,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default OutlineButton;
